import React, { useState } from "react";
import PlusImg from "../../../assets/plus.svg";
import DocumentImg from "../../../assets/document.svg";
import Close from "../../../assets/close.svg";
import Save from "../../../assets/save.svg";
import { TravelClaimFileInList } from "../../../types/travelClaims";
import { getFileName, getFileSize } from "../../../helpers/media";
import { tripsAPI } from "../../../api";
import { deleteTravelClaimPrimaryFile } from "../../../services/travelClaims";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import DeleteRed from "../../../assets/delete_red.svg";
import { Attachment as AttachmentCard } from "../../attachment/Attachment";
import { ColleagueDocAttachment } from "../../attachment/Attachment";
import { Media } from "../../../types/media";

interface AttachmentsProps {
    list: Array<TravelClaimFileInList>
    getFile?: (id: string) => Media | undefined;
}

interface AttachmentsEditProps extends AttachmentsProps {
    claim_pk: string
}

interface AttachmentProps {
    file_obj: TravelClaimFileInList
    onOpenModal?: (file: TravelClaimFileInList) => void;
}

interface AttachmentEditProps extends AttachmentProps {
    claim_pk: string
}


interface FileInfo {
    name: string;
    progress: number;
    status: string;
}

export const AttachmentsEdit = ({ list, claim_pk }: AttachmentsEditProps) => {
    const queryClient = useQueryClient();
    const [fileInfo, setFileInfo] = useState<FileInfo | null>(null);

    // Загрузка файла
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const inputFile = e.target.files[0];

            const newFile: FileInfo = { name: inputFile.name, progress: 0, status: 'Uploading' };
            setFileInfo(newFile);

            const formData = new FormData();
            formData.append('media', inputFile);

            try {
                const response = await tripsAPI.post(
                    `claim/${claim_pk}/primary_files/`,
                    formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                        console.log("UPLOADING % " + percentCompleted);
                        setFileInfo(prevState =>
                            prevState ? { ...prevState, progress: percentCompleted } : prevState
                        );
                    },
                });
                setFileInfo(prevState =>
                    prevState ? { ...prevState, status: 'Uploaded', progress: 100 } : prevState
                );
                setFileInfo(null);

                // Инвалидация файлов после успешной загрузки
                queryClient.invalidateQueries({ queryKey: ["travelClaimFiles"] })
            } catch (error) {
                setFileInfo(prevState =>
                    prevState ? { ...prevState, status: 'Error', progress: 100 } : prevState
                );
            }
        }
    };

    const handleRemoveFailed = () => {
        setFileInfo(null)
    }

    return (
        <div className="px-5 mb-10 flex w-full items-start gap-5 relative flex-[0_0_auto]">
            <div className="flex flex-col w-full items-start gap-2.5 relative">
                <div className="mb-2 flex w-full flex-row justify-between items-center gap-5 relative flex-[0_0_auto]">
                    <div> Вложения</div>
                    <div
                        className="
                        flex
                        flex-row
                        justify-end
                        items-center
                        relative w-fit
                        text-downloadbtdefault
                        text-right
                        leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                        whitespace-nowrap
                        font-manager-acrom-ph1-16-medium-acrom
                            font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                            text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                        tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                        [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                        ">
                        <label
                            htmlFor="upload-primary-file"
                            className="
                            cursor-pointer
                            w-1/2 inline-flex justify-end items-center gap-0.5 relative flex-[0_0_auto]"
                        >
                            <img alt="" src={PlusImg} className="!relative !w-6 !h-6" />
                            Загрузить документ
                        </label>
                        <input
                            id="upload-primary-file"
                            type="file"
                            onChange={handleFileChange}
                            className="hidden">
                        </input>
                    </div>
                </div>
                {/*FILES*/}
                {fileInfo && <UploadingAttachment
                    name={fileInfo.name}
                    progress={fileInfo.progress}
                    onClick={handleRemoveFailed}
                    status={fileInfo.status}
                />}
                <div className="flex flex-wrap -mb-4 w-full justify-between items-center gap-y-3">
                    {list.map((document, index) => (
                        <AttachmentEdit key={index} claim_pk={claim_pk} file_obj={document} />))}
                </div>
            </div>
        </div>);
};

interface UploadingFileProps {
    onClick: () => void
    progress: number
    name: string
    status?: string
}

export const UploadingAttachment = ({ progress, name, status, onClick }: UploadingFileProps) => {
    const bgColor = status === 'Error' ? 'bg-red-100 ' : 'bg-emerald-100 '
    return (
        <div
            className="
            w-[49%]
            inline-flex items-center
            gap-2.5 px-2 py-1.5
            relative flex-[0_0_auto]
            rounded-lg border-[0.5px] border-solid border-[#949494]"
        >
            {/*Фон загрузки*/}
            <div
                /*Ширину фона добавлять только так, если с классами, то глючит */
                style={{
                    width: progress + '%'
                }}
                className={"absolute top-0 left-0 rounded-lg h-full " + bgColor}
            ></div>
            {/*Очистить незагруженный файл*/}
            {status === 'Error' && <img
                onClick={onClick}
                alt=""
                src={Close}
                className="cursor-pointer !top-3 !absolute !w-6 !h-6 !right-0" />}

            <div className="relative w-full h-9">
                <div className="
                    inline-flex items-center gap-2.5
                ">
                    <img alt="" src={DocumentImg} className="!relative !w-6 !h-6" />
                    <div className="inline-flex flex-col justify-center flex-[0_0_auto] items-start relative">
                        <div
                            className="relative w-fit mt-[-1.00px] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                            {getFileName(name, 16)}
                        </div>
                        <div
                            className="relative w-fit text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                            {status === 'Error' && "Ошибка"}
                            {status === 'Uploading' && "Загрузка..."}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export const Attachment = ({ file_obj, onOpenModal }: AttachmentProps) => {

    const handleOpen = () => {
        console.log('Tsp open', onOpenModal)
        if (onOpenModal) {
            onOpenModal(file_obj);
        }
    };

    return (
        <button
            onClick={handleOpen}
            className="px-5 flex flex-row justify-between items-center w-[49%] h-12 flex-[0_0_auto] rounded-lg bg-[#f2f2f2] ">
            <AttachmentCard file_obj={file_obj} />
            <div className="inline-flex w-full flex-row justify-start items-center gap-2.5 ">
                <img alt="" src={DocumentImg} className="!relative !w-6 !h-6" />
                <div
                    className="inline-flex justify-center relative flex-[0_0_auto] flex-col items-start">
                    <div
                        className="relative w-fit mt-[-1.00px] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {file_obj?.media_info.original_name && getFileName(file_obj?.media_info.original_name)}
                    </div>
                    <div
                        className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {file_obj?.media_info.size}MB
                    </div>
                </div>
            </div>
            <img alt="" src={Save} className="!w-6 !h-6" />
        </button>
    );
}
export const AttachmentEdit = ({ file_obj, claim_pk }: AttachmentEditProps) => {
    const queryClient = useQueryClient();
    // Запрос на удаление
    const { mutate: deleteFile, isPending } = useMutation({
        mutationFn: ({ pk, claim_pk }: { pk: string, claim_pk: string }) => deleteTravelClaimPrimaryFile(pk, claim_pk),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["travelClaimFiles"] })
        }
    });

    const handleRemove = (pk: string) => {
        deleteFile({ pk, claim_pk })
    }
    return (
        <div
            className="
            px-2 flex flex-row
            justify-between items-center w-[49%] h-12 flex-[0_0_auto] rounded-lg bg-[#f2f2f2] ">
            <div className="inline-flex w-full flex-row justify-start items-center gap-2.5 ">
                <img alt="" src={DocumentImg} className="!relative !w-6 !h-6" />
                <div
                    className="inline-flex justify-center relative flex-[0_0_auto] flex-col items-start">
                    <div
                        className="relative w-fit mt-[-1.00px] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {file_obj?.media_info.original_name && getFileName(file_obj?.media_info.original_name)}
                    </div>
                    <div
                        className="relative w-fit font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {/*{getFileSize(file_obj?.media_info.size)}*/}
                        {file_obj?.media_info.size} MB
                    </div>
                </div>
            </div>
            <button
                onClick={() => handleRemove(file_obj.pk)}
                className="cursor-pointer relative w-6 h-6">
                <img alt="" src={DeleteRed} className="!relative !w-4 !h-4" />
            </button>
        </div>
    );
}

export const Attachments = ({ list, getFile }: AttachmentsProps) => {
    const handleDownload = (file_obj: TravelClaimFileInList) => {
        const link = window.document.createElement('a');
        if (!file_obj) {
            return
        }
        link.href = file_obj.media_info.file;
        link.download = file_obj.media_info.original_name;
        // Открываем окно "Сохранить как"
        link.target = '_blank';
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
    };

    return (
        <div className="pt-5 pr-5 pl-5 pb-0 mb-0 flex w-full items-start gap-5 relative flex-[0_0_auto]">
            <div className="flex flex-col w-full items-start gap-2.5 relative">
                <div className="w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                    Вложения
                </div>
                <div className="flex flex-col gap-1 h-full w-full py-1">
                    {list?.map((file_obj) => (
                        <div
                            key={file_obj.pk}
                            className="
                            flex
                            flex-col
                            flex-[0_0_auto]
                            items-start
                            gap-3
                            mx-4
                            py-4
                            border-b-[1px]
                            border-b-gray-200"
                        >
                            <ColleagueDocAttachment
                                file_obj={file_obj}
                                handleRemove={() => { }}
                                getFile={(id) => getFile ? getFile(id) : undefined}
                                handleDownload={(file) => {
                                    handleDownload(file)
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};